import { ApiFetchStatus, AppDetailsFetchErrorType } from "@tdp/common/constants";
import z from "zod";

export const IPeoplePickerResponseSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  userPrincipalName: z.string()
});

export type IPeoplePicker = z.infer<typeof IPeoplePickerResponseSchema>;

interface PeoplePickerFetchResultError {
  type: ApiFetchStatus.ERROR;
  errorType: AppDetailsFetchErrorType;
  errorMessage: string;
}

interface PeoplePickerFetchResultSuccess {
  type: ApiFetchStatus;
  response: IPeoplePicker[];
}

export type PeoplePickerFetchResult = PeoplePickerFetchResultError | PeoplePickerFetchResultSuccess;

export interface IPeoplePickerReader {
  readUsers(input: string): Promise<PeoplePickerFetchResult>;
}